import axios from 'axios';
import { opsStorageUtil } from './opsStorage';

/**
 * 运维平台专用 API 请求工具
 * 使用独立的存储工具，与用户界面完全隔离
 */
const opsRequest = axios.create({
  baseURL: process.env.VUE_APP_API_BASE_URL || '/api',
  timeout: 60000,
  headers: {
    'Content-Type': 'application/json'
  }
});

// 请求拦截器
opsRequest.interceptors.request.use(
  config => {
    try {
      // 添加 token（如果存在）
      const token = localStorage.getItem('ops_token');
      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
      }
      
      // 使用运维平台专用的存储工具获取用户信息
      try {
        const user = opsStorageUtil.getUser();
        if (user && user.id) {
          config.headers['x-ur-id'] = String(user.id); // 确保是字符串
        }
      } catch (userError) {
        console.warn('[OpsRequest] 获取用户信息失败:', userError);
        // 继续执行，不中断请求
      }
    } catch (error) {
      console.error('[OpsRequest] 请求拦截器错误:', error);
      // 不中断请求，让服务器处理
    }
    return config;
  },
  error => {
    console.error('[OpsRequest] 请求拦截器错误:', error);
    return Promise.reject(error);
  }
);

// 响应拦截器
opsRequest.interceptors.response.use(
  response => {
    const res = response.data;
    // 统一处理响应格式 Result<T>
    if (res.code !== undefined) {
      if (res.code !== 200) {
        return Promise.reject(new Error(res.message || '请求失败'));
      }
      // 返回整个 Result 对象，让调用方可以访问 code、message、data
      return res;
    }
    // 如果没有 code 字段，直接返回数据（兼容其他格式）
    return res;
  },
  error => {
    // 详细错误日志
    if (error.response) {
      // 服务器返回了错误响应
      console.error('[OpsRequest] API Error:', {
        status: error.response.status,
        statusText: error.response.statusText,
        url: error.config?.url,
        method: error.config?.method?.toUpperCase(),
        baseURL: error.config?.baseURL,
        fullURL: `${error.config?.baseURL}${error.config?.url}`,
        data: error.response.data
      });
    } else if (error.request) {
      // 请求已发出但没有收到响应
      console.error('[OpsRequest] Network Error:', {
        url: error.config?.url,
        method: error.config?.method?.toUpperCase(),
        baseURL: error.config?.baseURL,
        message: error.message
      });
    } else {
      // 请求配置出错
      console.error('[OpsRequest] Request Error:', error.message);
    }
    return Promise.reject(error);
  }
);

export default opsRequest;

